// Ubicación en el repo: src/pages/Settings.jsx
// "Configuración" — mismo contenedor con sub-pestañas que renderConfiguracion()
// del prototipo (línea ~2669): Apariencia, Profesionales, Catálogo e
// Inventario, Sucursales. Acá cada sub-pestaña reutiliza la pantalla ya
// construida tal cual (Professionals/Catalog/Branches), solo cambia dónde
// viven en la navegación — antes eran 3 links de nivel superior, ahora
// quedan agrupados en uno solo, igual que el prototipo.
import { useEffect, useState } from 'react';
import { useOutletContext, useSearchParams } from 'react-router-dom';
import { getClinicSettings, applyClinicSettings, DEFAULT_SETTINGS } from '../lib/clinicSettings';
import AppearanceSettings from '../components/AppearanceSettings';
import LegalSettings from '../components/LegalSettings';
import BackupSettings from '../components/BackupSettings';
import HolidaysSettings from '../components/HolidaysSettings';
import SchedulingSettings from '../components/SchedulingSettings';
import Professionals from './Professionals';
import Catalog from './Catalog';
import Branches from './Branches';
import PatientsTrash from '../components/PatientsTrash';
import PatientsExport from '../components/PatientsExport';
import Spinner from '../components/Spinner';

const TABS = [
  { key: 'apariencia', label: '🎨 Apariencia' },
  { key: 'legal', label: '⚖️ Datos legales' },
  { key: 'profesionales', label: '👤 Profesionales' },
  { key: 'catalogo', label: '📦 Catálogo e Inventario' },
  { key: 'sucursales', label: '🏢 Sucursales' },
  { key: 'feriados', label: '📅 Feriados y cierres' },
  { key: 'agenda-online', label: '🔗 Agenda online' },
  { key: 'papelera', label: '🗑️ Papelera' },
  { key: 'exportar', label: '📊 Exportar' },
  { key: 'backup', label: '💾 Backup' },
];

export default function Settings() {
  const { professional } = useOutletContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = TABS.some((t) => t.key === searchParams.get('tab')) ? searchParams.get('tab') : 'apariencia';
  const [tab, setTab] = useState(initialTab);

  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getClinicSettings()
      .then((s) => {
        setSettings(s);
        applyClinicSettings(s);
      })
      .catch((err) => setError(err.message || 'No se pudo cargar la apariencia.'))
      .finally(() => setLoading(false));
  }, []);

  function selectTab(key) {
    setTab(key);
    setSearchParams({ tab: key }, { replace: true });
  }

  return (
    <div className="patients-page">
      <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            className={tab === t.key ? 'button-primary' : 'button-secondary'}
            onClick={() => selectTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {error && <p className="auth-error">{error}</p>}

      {tab === 'apariencia' &&
        (loading ? (
          <Spinner />
        ) : (
          <AppearanceSettings
            settings={settings}
            isAdmin={!!professional?.is_admin}
            actorId={professional.id}
            onSaved={setSettings}
          />
        ))}
      {tab === 'legal' &&
        (loading ? (
          <Spinner />
        ) : (
          <LegalSettings
            settings={settings}
            isAdmin={!!professional?.is_admin}
            actorId={professional.id}
            onSaved={setSettings}
          />
        ))}
      {tab === 'profesionales' && <Professionals />}
      {tab === 'catalogo' && <Catalog />}
      {tab === 'sucursales' && <Branches />}
      {tab === 'feriados' && (
        <HolidaysSettings isAdmin={!!professional?.is_admin} actorId={professional.id} />
      )}
      {tab === 'agenda-online' &&
        (loading ? (
          <Spinner />
        ) : (
          <SchedulingSettings
            settings={settings}
            isAdmin={!!professional?.is_admin}
            actorId={professional.id}
            onSaved={setSettings}
          />
        ))}
      {tab === 'papelera' && <PatientsTrash isAdmin={!!professional?.is_admin} />}
      {tab === 'exportar' && <PatientsExport />}
      {tab === 'backup' && <BackupSettings />}
    </div>
  );
}
